export enum POST_MESSAGE_TYPE {
    // 取消編輯器元素檢視
    RELEASE_UI_ELEMENT = 'RELEASE_UI_ELEMENT',

    // 選取編輯器元素檢視
    PICK_UI_ELEMENT = 'PICK_UI_ELEMENT',

    // 新增元件
    ADD_UI_ELEMENT = 'ADD_UI_ELEMENT',

    // 更新資料 ui element
    UPDATE_UI_ELEMENT = 'UPDATE_UI_ELEMENT',

    // 更新資料 ui element content
    UPDATE_UI_ELEMENT_CONTENT = 'UPDATE_UI_ELEMENT_CONTENT',

    // 更新 section 順序
    UPDATE_PAGE_TREE = 'UPDATE_PAGE_TREE',

    // 隱藏 section
    DISABLE_SECTION = 'DISABLE_SECTION',

    // 刪除 component
    DELETE_COMPONENT = 'DELETE_COMPONENT',

    // 同步資料 shop template
    INITIALIZE_SHOP_PAGE_LAYOUT = 'INITIALIZE_SHOP_PAGE_LAYOUT',

    // 同步資料 shop template 結束
    FINISH_INITIALIZE_SHOP_PAGE_LAYOUT = 'FINISH_INITIALIZE_SHOP_PAGE_LAYOUT',

    // 滑鼠移入 iframe
    POINTER_IN_IFRAME = 'POINTER_IN_IFRAME',

    // 滑鼠移出 iframe
    POINTER_OUT_IFRAME = 'POINTER_OUT_IFRAME',

    // iframe 準備好讀取資料
    IFRAME_READY_TO_READ = 'IFRAME_READY_TO_READ',

    // 更新最接近畫面中心的 section id
    UPDATE_CLOSEST_SECTION_ID = 'UPDATE_CLOSEST_SECTION_ID',

    // 更新 site style
    UPDATE_SITE_STYLE = 'UPDATE_SITE_STYLE',

    // 開始拖曳
    START_DRAG_COMPONENT = 'START_DRAG_COMPONENT',

    // 拖曳結束
    END_DRAG_COMPONENT = 'END_DRAG_COMPONENT',

    // sync 資料
    SYNC_DATA = 'SYNC_DATA',

    // 預覽模式下按下快捷鍵
    PREVIEW_KEY_DOWN = 'PREVIEW_KEY_DOWN',

    // 重命名 section
    RENAME_SECTION = 'RENAME_SECTION',

    // 滾動至 section
    SCROLL_TO_SECTION = 'SCROLL_TO_SECTION',

    // 更新 media upload 狀態
    UPDATE_MEDIA_UPLOADING_STATUS = 'UPDATE_MEDIA_UPLOADING_STATUS',

    // 刪除 media upload 狀態
    DELETE_MEDIA = 'DELETE_MEDIA',

    // 更新 isSaving
    SAVE = 'SAVE',

    // 更新 progressPercent
    UPDATE_PROGRESS_PERCENT = 'UPDATE_PROGRESS_PERCENT',

    // 複製元件
    DUPLICATE_COMPONENT = 'DUPLICATE_COMPONENT',

    // 移動元件
    MOVE_COMPONENT = 'MOVE_COMPONENT',

    // 外部拖曳新增元件
    EXTERNAL_ADD_COMPONENT = 'EXTERNAL_ADD_COMPONENT',
}
